import { Button } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const VersionSwitchButton = () => {
  const isAdvisor = useSelector((state: any) => state.auth.isAdvisor);
  const isCollab = useSelector((state: any) => state.auth.isCollab);

  const handleVersionSwitch = () => {
    window.location.href = "/__switch/v4";
  };

  if (!isAdvisor && !isCollab) return null;

  return (
    <div>
      <Button
        onClick={handleVersionSwitch}
        variant="outlined"
        sx={{ fontSize: "12px", padding: "12px 24px" }}
      >
        Tester la nouvelle version (Bêta)
      </Button>
    </div>
  );
};

export default VersionSwitchButton;
